import { useRef } from "react";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
} from "@chakra-ui/react";

const PreventNavigationAlert = ({
  onClose,
  isOpen,
  onContinue,
  message = `If you navigate away from this page, your changes will be lost.`,
}: {
  onClose: () => void;
  isOpen: boolean;
  onContinue: () => void;
  message?: string;
}) => {
  const cancelRef = useRef(null);
  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay
        display="flex"
        alignItems="center"
        justifyContent="center"
        p={{ base: 4, md: 0 }}
      />
      <AlertDialogContent>
        <AlertDialogHeader textStyle="h4">Are you sure?</AlertDialogHeader>
        <AlertDialogBody color="grey.500" textStyle="body2">
          {message} Are you sure you want to continue?
        </AlertDialogBody>
        <AlertDialogFooter>
          <Button ref={cancelRef} variant="outline" onClick={onClose}>
            Stay Here
          </Button>
          <Button
            colorScheme="red"
            variant="danger"
            ml={3}
            onClick={onContinue}
          >
            Continue
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default PreventNavigationAlert;
